import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
};

var _renditionList, _prevState, _render, render_fn, _onChange, onChange_fn;

import { MediaChromeListbox, createOption, createIndicator } from "./media-chrome-listbox.js";
import "./media-chrome-option.js";
import { globalThis } from "../utils/server-safe-globals.js";
import { getStringAttr, setStringAttr } from "../utils/element-utils.js";
import { parseRenditionList } from "../utils/utils.js";
import { MediaUIAttributes, MediaUIEvents } from "../constants.js";

var MediaRenditionListbox = /*#__PURE__*/function (_MediaChromeListbox) {
  _inherits(MediaRenditionListbox, _MediaChromeListbox);

  var _super = _createSuper(MediaRenditionListbox);

  function MediaRenditionListbox() {
    var _this;

    _classCallCheck(this, MediaRenditionListbox);

    _this = _super.apply(this, arguments);

    __privateAdd(_assertThisInitialized(_this), _render);

    __privateAdd(_assertThisInitialized(_this), _onChange);

    __privateAdd(_assertThisInitialized(_this), _renditionList, []);

    __privateAdd(_assertThisInitialized(_this), _prevState, void 0);

    return _this;
  }

  _createClass(MediaRenditionListbox, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      _get(_getPrototypeOf(MediaRenditionListbox.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);

      if (attrName === MediaUIAttributes.MEDIA_RENDITION_SELECTED && oldValue !== newValue) {
        this.value = newValue != null ? newValue : "auto";
      } else if (attrName === MediaUIAttributes.MEDIA_RENDITION_LIST && oldValue !== newValue) {
        __privateSet(this, _renditionList, parseRenditionList(newValue));

        __privateMethod(this, _render, render_fn).call(this);
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(MediaRenditionListbox.prototype), "connectedCallback", this).call(this);

      this.addEventListener("change", __privateMethod(this, _onChange, onChange_fn));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _get(_getPrototypeOf(MediaRenditionListbox.prototype), "disconnectedCallback", this).call(this);

      this.removeEventListener("change", __privateMethod(this, _onChange, onChange_fn));
    }
  }, {
    key: "mediaRenditionList",
    get: function get() {
      return __privateGet(this, _renditionList);
    },
    set: function set(list) {
      __privateSet(this, _renditionList, list);

      __privateMethod(this, _render, render_fn).call(this);
    }
  }, {
    key: "mediaRenditionSelected",
    get: function get() {
      return getStringAttr(this, MediaUIAttributes.MEDIA_RENDITION_SELECTED);
    },
    set: function set(id) {
      setStringAttr(this, MediaUIAttributes.MEDIA_RENDITION_SELECTED, id);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaRenditionListbox), "observedAttributes", this)), [MediaUIAttributes.MEDIA_RENDITION_LIST, MediaUIAttributes.MEDIA_RENDITION_SELECTED]);
    }
  }]);

  return MediaRenditionListbox;
}(MediaChromeListbox);

_renditionList = new WeakMap();
_prevState = new WeakMap();
_render = new WeakSet();

render_fn = function render_fn() {
  if (__privateGet(this, _prevState) === JSON.stringify(this.mediaRenditionList)) return;

  __privateSet(this, _prevState, JSON.stringify(this.mediaRenditionList));

  var renditionList = this.mediaRenditionList.sort(function (a, b) {
    return b.height - a.height;
  });
  var container = this.shadowRoot.querySelector("#container");
  container.textContent = "";
  var isAuto = !this.mediaRenditionSelected;

  var _iterator = _createForOfIteratorHelper(renditionList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rendition = _step.value;
      var text = this.formatOptionText("".concat(Math.min(rendition.width, rendition.height), "p"), rendition);
      var option2 = createOption(text, "".concat(rendition.id), rendition.selected && !isAuto);
      option2.prepend(createIndicator(this, "select-indicator"));
      container.append(option2);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var option = createOption(this.formatOptionText("Auto"), "auto", isAuto);
  option.prepend(createIndicator(this, "select-indicator"));
  container.append(option);
};

_onChange = new WeakSet();

onChange_fn = function onChange_fn() {
  if (this.value == null) return;
  var event = new globalThis.CustomEvent(MediaUIEvents.MEDIA_RENDITION_REQUEST, {
    composed: true,
    bubbles: true,
    detail: this.value
  });
  this.dispatchEvent(event);
};

if (!globalThis.customElements.get("media-rendition-listbox")) {
  globalThis.customElements.define("media-rendition-listbox", MediaRenditionListbox);
}

var media_rendition_listbox_default = MediaRenditionListbox;
export { MediaRenditionListbox, media_rendition_listbox_default as default };